import { zodResolver } from "@hookform/resolvers/zod";
import { TextareaAutosize } from '@mui/base';
import { Button, Card, Container, FormHelperText, Grid, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from "@mui/material/useMediaQuery";
import MyToastShow from "@/components/Layout/MyToast";
import { FormProvider, useForm } from "react-hook-form";
import { useEnviarConsultaMutation } from "@/redux/api/userApi";
import { TypeOf, object, string } from "zod";
import FormInput from "../../components/Auth/FormInput";

const contactSchema = object({
    email: string()
        .min(1, 'Necesitas ingresar un email')
        .email('El email no es valido'),
    nombre: string().nonempty('Necesitas ingresar un nombre'),
    apellido: string().nonempty('Necesitas ingresar un apellido'),
    asunto: string().nonempty('Necesitas ingresar un asunto'),
    empresa: string().optional(),
    consulta: string().nonempty('Necesitas ingresar un mensaje'),
});

export type ContactInput = TypeOf<typeof contactSchema>;


const ContactPage = () => {

    const [enviarConsulta] = useEnviarConsultaMutation();
    const methods = useForm<ContactInput>({
        resolver: zodResolver(contactSchema),

    });

    const theme = useTheme();
    const IsPc = useMediaQuery(theme.breakpoints.up('sm'));


    const onSend = (data: ContactInput) => {

        enviarConsulta(data).unwrap().then((res) => {
            MyToastShow({ message: res.message, type: 'success' })
            methods.reset();
        }).catch((err) => {
            MyToastShow({ message: 'Error al enviar la consulta', type: 'error' })
        })
    }


    return (
        <Container sx={{
            minHeight: 'calc(100vh - 210px)'
        }} >

            <Card variant="outlined" sx={{
                margin: IsPc ? '2rem' : '0.5rem',
                boxShadow: '-16px 18px 0px 3px #c3c0c040'
            }} >
                <Typography variant="h4" component="h1" align="center" pt={3} fontWeight='bold' fontSize='28px'>
                    Contactate con nosotros y resolvemos tus dudas
                </Typography>

                <FormProvider  {...methods}>
                    <form onSubmit={methods.handleSubmit(onSend)} >
                        <Grid container padding='2rem' >
                            <Grid item xs={12} md={6} p={1} >
                                <FormInput name="nombre" label="Nombre" type="text" />
                            </Grid>
                            <Grid item xs={12} md={6} p={1}>
                                <FormInput name="apellido" label="Apellido" type="text" />
                            </Grid>
                            <Grid item xs={12} md={6} p={1} >
                                <FormInput name="asunto" label="Asunto" type="text" />
                            </Grid>
                            <Grid item xs={12} md={6} p={1}>
                                <FormInput name="email" label="Email" type="email" />
                            </Grid>
                            <Grid item xs={12} p={1}>
                                <FormInput name="empresa" label="Empresa" type="company" />
                            </Grid>
                            <Grid item xs={12} p={1}>
                                <Typography variant="body2"
                                    sx={{ mb: 1, fontWeight: 500 }}> Dejá tu mensaje</Typography>
                                <TextareaAutosize aria-label="Mensaje"
                                    dirName="consulta"
                                    {...methods.register('consulta')}

                                    itemType="string"
                                    defaultValue=''
                                    minRows={3} style={{
                                        width: '100%', resize: 'vertical',
                                        maxHeight: '10rem',
                                        minHeight: '2rem',
                                        fontSize: '1rem',
                                        borderRadius: '0.7rem',

                                    }} />
                                <FormHelperText error={!!methods.formState.errors['consulta']}>
                                    {methods.formState.errors['consulta'] ? (methods.formState.errors['consulta']?.message as string) : ""}
                                </FormHelperText>
                            </Grid>
                            <Button variant="contained" type="submit" sx={{ width: '100%' }}>Enviar Consulta</Button>
                        </Grid>
                    </form>
                </FormProvider>

            </Card>
        </Container>

    );
}

export default ContactPage;